import { ChevronRight, KeyboardArrowDown } from '@mui/icons-material'
import { Box, Collapse, Divider, IconButton, Typography } from '@mui/material'
import React from 'react'
import { connect } from 'react-redux'
import UploadNewFile from 'components/documents/upload-prompt'
import { DOCUMENT_FILE_ADMIN_PERMISSION_CODES } from 'constants/permissions'
import {
  Operations as DocumentOperations,
  operations as documentOperations
} from 'states/dux/document/operations'
import { Payload as DocumentPayload } from 'states/dux/document/types'
import {
  Operations as LayoutOperations,
  operations as layoutOperations
} from 'states/dux/layout/operations'
import { Payload as LayoutPayload } from 'states/dux/layout/types'
import {
  Operations as ThemeOperations,
  operations as themeOperations
} from 'states/dux/theme/operations'
import { Payload as ThemePayload } from 'states/dux/theme/types'
import {
  Operations as UserOperations,
  operations as userOperations
} from 'states/dux/user/operations'
import { Payload as UserPayload } from 'states/dux/user/types'
import State from 'states/types'
import { NivosFile } from 'types/nivos-file'
import { NivosFolder } from 'types/nivos-folder'
import { capitalize, mapOperationsToDispatchProps } from 'utils/common'
import { hasPermissions } from 'utils/user'

interface StateProps {
  theme: ThemePayload
  layout: LayoutPayload
  document: DocumentPayload
  user: UserPayload
}

interface DispatchProps {
  operations: {
    theme: ThemeOperations
    layout: LayoutOperations
    document: DocumentOperations
    user: UserOperations
  }
}

interface OwnProps {
  category: string
  folder: NivosFolder
  expandedOnMount?: boolean
}

type AppProps = StateProps & DispatchProps & OwnProps

const DocumentListFC: React.FC<any> = (props: AppProps) => {
  const { category, folder, expandedOnMount, user, operations } = props
  const [unfold, setUnfold] = React.useState(!(expandedOnMount === false))
  const [open, setOpen] = React.useState(false)

  const DocumentListItem: React.FC<NivosFile> = props => {
    return (
      <Box
        display={'flex'}
        alignItems={'center'}
        padding={1}
        onClick={() => operations.document.setSelected(props)}
        sx={{
          ':hover': { paddingLeft: 3 },
          cursor: 'pointer',
          transition: '.40s',
          borderRadius: '4px'
        }}
      >
        <Typography variant={'body2'} width={0.3}>
          {props.name}
        </Typography>
        <Typography variant={'body2'} width={0.3} align={'center'}>
          {props.createdBy.fullName}
        </Typography>
        <Typography variant={'body2'} width={0.3} align={'right'}>
          {props.createdAt.toUTCString()}
        </Typography>
      </Box>
    )
  }

  return (
    <Box>
      <Box padding={1} />
      <Box display={'flex'} alignItems={'center'}>
        <IconButton onClick={() => setUnfold(!unfold)}>
          {unfold ? <KeyboardArrowDown /> : <ChevronRight />}
        </IconButton>
        <Typography flexGrow={1}>
          <strong>{capitalize(category)}</strong>
        </Typography>
      </Box>
      <Collapse in={unfold} timeout={750} unmountOnExit>
        <Box paddingLeft={6}>
          <Box display={'flex'} alignItems={'center'} padding={1}>
            <Typography variant={'body2'} width={0.3}>
              <strong>Filename</strong>
            </Typography>
            <Typography variant={'body2'} width={0.3} align={'center'}>
              <strong>Created By</strong>
            </Typography>
            <Typography variant={'body2'} width={0.3} align={'right'}>
              <strong>Created At</strong>
            </Typography>
          </Box>
          {folder.files.map((file, index) => (
            <Box key={index}>
              <Divider />
              <DocumentListItem {...file} />
            </Box>
          ))}
          {hasPermissions(user, DOCUMENT_FILE_ADMIN_PERMISSION_CODES) && (
            <UploadNewFile folder={folder} open={open} setOpen={setOpen} />
          )}
        </Box>
      </Collapse>
    </Box>
  )
}

const mapStateToProps = (state: State): StateProps => {
  return {
    theme: state.theme,
    layout: state.layout,
    document: state.document,
    user: state.user
  }
}

const mapDispatchToProps = mapOperationsToDispatchProps({
  theme: themeOperations,
  layout: layoutOperations,
  document: documentOperations,
  user: userOperations
})

const DocumentList = connect(
  mapStateToProps,
  mapDispatchToProps
)(DocumentListFC) as React.FC<OwnProps>

export default DocumentList
